import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetPotentialRevenueLossRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  from: z.string(),
  to: z.string(),
});

const GetPotentialRevenueLossResponseDtoSchema = z.object({
  changePct: z.number().nullable(),
  isOutperforming: z.boolean(),
  isSwitchedToLoss: z.boolean(),
  isSwitchedToOutperform: z.boolean(),
  potentialRevenueLoss: z.object({
    loss: z.number(),
    outperforming: z.number(),
  }),
});

export type GetPotentialRevenueLossRequestDto = z.infer<
  typeof _GetPotentialRevenueLossRequestDtoSchema
>;
export type GetPotentialRevenueLossResponseDto = z.infer<
  typeof GetPotentialRevenueLossResponseDtoSchema
>;

export const getPotentialRevenueLossKpi = (
  params: GetPotentialRevenueLossRequestDto,
  config?: AxiosRequestConfig<GetPotentialRevenueLossRequestDto>
) => {
  const { facilityId, ...queryParams } = params;

  return api
    .get(
      `market-intelligence/facilities/${facilityId}/potential-revenue-loss`,
      { params: queryParams, ...config }
    )
    .then(responseContract(GetPotentialRevenueLossResponseDtoSchema));
};
